import config from '@provider-portal/common/config';
import get from 'lodash/get';

import { createCredentialsReducer } from '@bolteu/redux-session';

export interface AuthenticateActionProps {
  username: string;
  password: string;
}

export type AuthenticateAction = (args?: AuthenticateActionProps) => void;

function getUserIdFromAccessToken(decodedToken: { [key: string]: unknown }) {
  return get(decodedToken, `data.${config.userIdKey}`, null);
}

export type { CredentialsSessionState as SessionState } from '@bolteu/redux-session';

export const sessionReducer = createCredentialsReducer({
  sessionIdValiditySeconds: config.sessionIdValidityMilliseconds,
  userType: config.userType,
  deviceId: '',
  getUserIdFromAccessToken,
});
